import React from "react";
import { useModal } from "@clayui/modal";
import FileUploader from "../../../common/components/FileUploader";
import { Formik } from 'formik';
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { beforeMaskedValueChangeRut, getPageLayoutType, isRutValid, transformId } from "../../../common/utils/utilsFunc";
import AlertModal from "../../../common/components/AlertModal";
import { CGE } from "../../../common/components/CGE";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../common/utils/cookiesUtil";
import useCookie from '../../../common/hooks/useCookie';

const MERCHANDISE_CLAIM_CODE = 'ZR0000100010';
const MERCHANDISE_DAMAGE_CODE = 'ZR0000100020';
const LESS_OR_EQUAL_AMOUNT = 'menor_igual_40000';
const GREATER_AMOUNT = 'mayor_a_40000';
const FILE_FIELD_NAMES = ['CedulaIdentidad', 'Cotizacion', 'InformeTecnico', 'FotoUno', 'FotoDos', 'FotoTres'];
const AMOUNT_OPTIONS = [
  { label: '[Seleccione una opción]', value: '' },
  { label: 'Menor o igual a $40.000', value: LESS_OR_EQUAL_AMOUNT },
  { label: 'Mayor que $40.000', value: GREATER_AMOUNT },
];

const FormsGeneric = ({ props, tag, setForm, solicitud, sociedad, setInputIdClient, state, setDpto, setPiso, setNumberFirst, setNumberSecond, 
  setNumberLast, setComuna, setCalle, setNroCalle, setInstalacion, setInstalacionComercial, detailClient, error, visibleModalError,
  optionsInteraction, allComunas,valueExist }) => {

  const properties = React.useContext(ApplicationPropertiesContext);
  const [emptyInput, setEmptyInput] = React.useState(false);
  const [validatedInput, setValidatedInput] = React.useState(false)
  const [buttonHandleClick, setButtonHandleClick] = React.useState(false)
  const [buttonHandleClickClient, setButtonHandleClickClient] = React.useState(false)
  const [buttonHandleClickClientEmpty, setButtonHandleClickClientEmpty] = React.useState(false)
  const [errorsForms, setErrosForms] = React.useState([])
  const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
  const [valueCheckBox, setValueCheckBox] = React.useState(false);
  const [responseService, setResponseService] = React.useState('')
  const [inputClientPublic, setInputClientPublic] = React.useState('')
  const [visibleModal, setVisibleModal] = React.useState(false);
  const [visibleModal2, setVisibleModal2] = React.useState(false);
  const [errorSubmitting, setErrorSubmitting] = React.useState(false);
  const [showForm, setShowForm] = React.useState(false);
  const [selectedClaimType, setSelectedClaimType] = React.useState('0');
  const [erroUploadFile, setErroUploadFile] = React.useState();
  const contingencyEnabled = state.listInteraction?.contingencyEvent === true;
  const isContingencyMerchandiseClaim = contingencyEnabled && selectedClaimType === MERCHANDISE_CLAIM_CODE;
  const isDamagedApplianceClaim = selectedClaimType === MERCHANDISE_DAMAGE_CODE;
  
  const { observer, onClose } = useModal({
    onClose: () => {
      setVisibleModal(false)
      setVisibleModal2(false)
      setInputClientPublic('')
    }
  });
  const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

  let data = state.idList ? state.idList : [];
  let dataComuna = state.comuna ? state.comuna : []
  let optionsIdsSelect = [];
  let optionsComuna = [];


  function clearFileInput(fieldName) {
    const input = document.getElementById(fieldName);
    if (input) {
      input.value = '';
    }
  }

  function clearFileFields(setFieldValue, fieldNames = FILE_FIELD_NAMES) {
    fieldNames.forEach((fieldName) => {
      setFieldValue(fieldName, '');
      clearFileInput(fieldName);
    });
  }

  function handleSelectChange(e, setFieldValue, currentClaimType) {
    const selectedId = e.target.value;
    if (selectedId === currentClaimType) {
      return;
    }
    setFieldValue('CdgTipoReclamo', selectedId);
    setFieldValue('EstimacionMontoAfectacion', '');
    setSelectedClaimType(selectedId);
    clearFileFields(setFieldValue);

    if (selectedId === MERCHANDISE_DAMAGE_CODE || selectedId === MERCHANDISE_CLAIM_CODE) {
      setShowForm(true); 
    } else {
      setShowForm(false); 
    }
  }

  function handleAmountChange(e, setFieldValue, currentAmount) {
    const selectedAmount = e.target.value;
    if (selectedAmount === currentAmount) {
      return;
    }
    setFieldValue('EstimacionMontoAfectacion', selectedAmount);
    clearFileFields(setFieldValue, ['InformeTecnico', 'FotoUno', 'FotoDos', 'FotoTres']);
    if (selectedAmount !== GREATER_AMOUNT) {
      clearFileFields(setFieldValue, ['Cotizacion']);
    }
  }

  if (getPageLayoutType()) {
    optionsIdsSelect = [
      {
        label: "[Seleccione una opción]",
        value: "",
      },
    ];
    data.forEach((id) => {
      optionsIdsSelect.push({ label: id, value: id });
    });
  }

  optionsComuna = [
    {
      label: "[Seleccione Comuna]",
      value: "",
    }
  ];

  if (state.comuna?.code === 0) {
    dataComuna?.comunas.forEach((item) => {
      optionsComuna.push({ label: item.nomComuna, value: item.codigoSAP })
    })
  }

  function onChangeReCaptcha(value) {
    updateCookieState(value);
    if (value) {
      setVerifReCaptcha(true);
    }
    else {
      setVerifReCaptcha(false);
    }
  }

  function handleClickClient() {
    if (!inputClientPublic) {
      setButtonHandleClickClientEmpty(true)
    } else {
      setInputIdClient(inputClientPublic)
      setButtonHandleClickClientEmpty(false)
    }
  }

  React.useEffect(() => {

    if (error) {
      setResponseService('')
    }

    if (state.responseService && tag === "RI") {

      setVisibleModal(true)
      setInputIdClient('')
      setResponseService(state.responseService)
      setButtonHandleClickClient(false)
    } else {
      setVisibleModal(false)
      setResponseService('')
    }


  }, [state.responseService])

  function handleChangePriv(event) {
    setInputIdClient(event.target.value)
    setButtonHandleClickClient(false)
    setButtonHandleClickClientEmpty(false)
  }

  React.useEffect(() => {
    if ((emptyInput || validatedInput) &&  buttonHandleClick) {
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
      setButtonHandleClick(false);
    } else if (!emptyInput && !validatedInput && !verifReCaptcha && buttonHandleClick) {
      props.setGlobalAlert('Falta validar que no eres un Robot.', "warning");
      setButtonHandleClick(false);
    } else if (!emptyInput && verifReCaptcha && errorSubmitting) {
      props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.", "warning");
    }
  }, [emptyInput, verifReCaptcha, buttonHandleClick, errorSubmitting])

  React.useEffect(() => {
    if(erroUploadFile) {
        props.setGlobalAlert(erroUploadFile, "warning");
    }
   },[erroUploadFile]);

  let propsLabelInfoContent = {
    "content": state?.webContentTextInfo,
    "observer": observer,
    "onClose": onClose,
    "setVisibleModal": setVisibleModal2,
    "status": "info",
    "titleModal": "Información",
    "visibleModal": visibleModal2,
    "titleHint": "Ayuda Nro de Cliente",
}

  return (
    <div className="">
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        validateOnMount={false}
        initialValues={{
          Calle: valueExist?.calle?valueExist?.calle:"", 
          CuentaContrato: getPageLayoutType() ? "0" : "", //parte privada:select; parte pub:input vazio
          OrigenReclamo: getPageLayoutType() ? "Oficina Virtual" : "Página Web",
          socialReason: "", 
          Empresa: sociedad,
          Comuna: valueExist?.comuna?valueExist?.comuna: "0",  
          CdgComuna: 0,
          NroCalle: valueExist?.setNroCalle ?valueExist?.setNroCalle:"", 
          NombReclamante:valueExist?.nombre?valueExist?.nombre:"",
          lastName:valueExist?.apelidoParterno?valueExist?.apelidoParterno:"",
          motherLastName:valueExist?.apelidoMaterno?valueExist?.apelidoMaterno:"",
          RUTReclamante: valueExist?.rut?valueExist?.rut:"",
          ComunaReclamante: valueExist?.comuna?valueExist?.comuna: "0", 
          CalleReclamante: valueExist?.calle?valueExist?.calle:"", 
          NroCalleReclamante: valueExist?.num?valueExist?.num:"", 
          blockOrDptoReclamante: valueExist?.blockDpto?valueExist?.blockDpto:"", 
          EmailReclamante: valueExist?.email?valueExist?.email:"", 
          TelefReclamante: valueExist?.telefono?valueExist?.telefono:"",
          CelularReclamanete: valueExist?.telefono?valueExist?.telefono:"",
          CdgTipoReclamo: "0", 
          labelCdgTipoReclamo: "",
          OfrecePeligro: "N", 
          Observacion: "", 
          Instalacion: "",
          InterlocutorComercial: "",
          Fecha: "",
          EstimacionMontoAfectacion: "",
          CedulaIdentidad: "",
          Cotizacion: "",
          InformeTecnico: "",
          FotoUno: "",
          FotoDos: "",
          FotoTres: ""
        }}
        validate={(values) => {
          let errors = {
            empty: {},
            validated: {},
          };

          if (values.RUTReclamante && !isRutValid(values.RUTReclamante)) {
            errors.validated.RUTReclamante = true;
          }

          if (!values.RUTReclamante || !String(values.RUTReclamante).trim()) {
            errors.empty.RUTReclamante = true;
          }

          if (values.CdgTipoReclamo !== "0") {
            values.labelCdgTipoReclamo = document.getElementById('CdgTipoReclamo')?.options[document.getElementById('CdgTipoReclamo')?.options.selectedIndex]?.label
          }

          if (!values.ComunaReclamante || values.ComunaReclamante === "0" || values.ComunaReclamante === 0) {
            errors.empty.ComunaReclamante = true;
          }

          if (document.getElementById('CdgTipoReclamo').value !== "0" && values.CdgTipoReclamo === "0") {
            values.CdgTipoReclamo = document.getElementById('CdgTipoReclamo').value;
          } else if (values.CdgTipoReclamo === "0") {
            errors.empty.CdgTipoReclamo = true;
          }

          if (setInstalacion) {
            values.Instalacion = setInstalacion
          }

          if (setInstalacionComercial) {
            values.InterlocutorComercial = setInstalacionComercial
          }
          if (values.CuentaContrato === "0" && getPageLayoutType()) {
            errors.empty.CuentaContrato = true;
          }

          if (values.TelefReclamante) {
            values.CelularReclamanete = values.TelefReclamante
          }

          if (!values.CuentaContrato) {
            errors.empty.CuentaContrato = true;
          }

          if (values.CuentaContrato && detailClient?.CTA_CTO === values.CuentaContrato) {
            setErrorSubmitting(false)
          }

          if (!values.NombReclamante) {
            errors.empty.NombReclamante = true;
          }

          if (!values.lastName) {
            errors.empty.lastName = true;
          }

          if (!values.motherLastName) {
            errors.empty.motherLastName = true;
          }

          if (!values.CalleReclamante) {
            errors.empty.CalleReclamante = true;
          }

          if (!values.NroCalleReclamante) {
            errors.empty.NroCalleReclamante = true;
          }
          if (!values.Observacion) {
            errors.empty.Observacion = true;
          }

          if (!values.TelefReclamante) {
            errors.empty.TelefReclamante = true;
          }
          if (values.EmailReclamante && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.EmailReclamante)) {
            errors.validated.EmailReclamante = true;
          }
          if (!values.EmailReclamante) {
            errors.empty.EmailReclamante = true;
          }
          if (showForm) {
            if (!values.Fecha) {
              errors.empty.Fecha = true;
            }
            if (!values.CedulaIdentidad) {
              errors.empty.CedulaIdentidad = true;
            }

            if (contingencyEnabled && values.CdgTipoReclamo === MERCHANDISE_CLAIM_CODE) {
              if (!values.EstimacionMontoAfectacion) {
                errors.empty.EstimacionMontoAfectacion = true;
              }
              if (values.EstimacionMontoAfectacion === GREATER_AMOUNT && !values.Cotizacion) {
                errors.empty.Cotizacion = true;
              }
            } else {
              if (values.CdgTipoReclamo !== MERCHANDISE_DAMAGE_CODE && !values.Cotizacion) {
                errors.empty.Cotizacion = true;
              }
              if (values.CdgTipoReclamo !== MERCHANDISE_DAMAGE_CODE && !values.InformeTecnico) {
                errors.empty.InformeTecnico = true;
              }
              if (!values.FotoUno) {
                errors.empty.FotoUno = true;
              }
            }
          }
          if (values.TelefReclamante && !/^[0-9]{9}$/i.test(values.TelefReclamante)) {
            if (!/^[0-9]{10}$/i.test(values.TelefReclamante)) {
              errors.validated.TelefReclamante = true;
            }
          }

          if (Object.keys(errors?.empty)?.length > 0) {
            setEmptyInput(true);
          } else {
            setEmptyInput(false);
          }

          if (Object.keys(errors?.validated)?.length > 0) {
            setValidatedInput(true);
          } else {
            setValidatedInput(false);
          }

          if (Object.keys(errors?.empty)?.length > 0 || Object.keys(errors?.validated)?.length > 0 || (!verifReCaptcha && !getPageLayoutType())) {
            setButtonHandleClick(true)
          } else {
            setButtonHandleClick(false)
          }

          if (Object.keys(errors?.validated)?.length === 0 && Object.keys(errors?.empty)?.length === 0) {
            errors = {};
          }
          setErrosForms(errors)
          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm, setFieldValue}) => {

          if (buttonHandleClick) {
            setButtonHandleClick(false)
          }


          if (values.CuentaContrato && (transformId(detailClient?.CTA_CTO) === transformId(values.CuentaContrato))) {
            if (verifReCaptcha && !getPageLayoutType()){
              setForm(values);
              setErrorSubmitting(false)
              resetForm();
              clearFileFields(setFieldValue);
              setSelectedClaimType('0');
              setShowForm(false);
            } else if(getPageLayoutType()){
              setForm(values);
              setErrorSubmitting(false)
              resetForm();
              clearFileFields(setFieldValue);
              setSelectedClaimType('0');
              setShowForm(false);
            }
          } else {
            setErrorSubmitting(true)
            setForm(null);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <CGE.PanelSection title="1. Identificación del cliente">
              <div class="row">
                <div class="col-md-12">
                  <CGE.DetailClient
                    props={{
                      handleChangePriv: (event) => {
                        handleChange(event)
                        handleChangePriv(event)
                        setInputClientPublic(event.target.value)
                      },
                      handleChange: (event) => {
                        handleChange(event)
                        setInputClientPublic(event.target.value)
                      },
                      idClient: values.CuentaContrato,
                      hasError: errors?.empty?.CuentaContrato || buttonHandleClickClientEmpty,
                      msgError: 'Debes ingresar el Nro de Cliente',
                      idFormElement: "CuentaContrato",
                      labelName: "Número de Cliente:",
                      typeElement: getPageLayoutType() ? "select" : "input-mask",
                      typeFormElement: "text",
                      mandatoryElement: true,
                      valuePriv: !responseService ? values.CuentaContrato : values.CuentaContrato = '0',
                      valuePub: !responseService && !visibleModal ? values.CuentaContrato : values.CuentaContrato = inputClientPublic,
                      listOptions: optionsIdsSelect,
                      labelButton: getPageLayoutType() ? "" : "Consultar",
                      handleClick: handleClickClient,
                      propsLabelInfoContent: !getPageLayoutType() ? propsLabelInfoContent : "",
                      sizeButton: "sm",
                      typeButton: "primary",
                      versionButton:"button",
                      maxLength:"12",
                      formatChars:{
                          9: "[0-9]"
                      },
                      mask:"999999999999",
                    }}
                    propsDetail={{
                      fullNameClient: (setNumberFirst || setNumberSecond
                        || setNumberLast) ? values.socialReason = `${setNumberFirst} ${setNumberSecond} ${setNumberLast}` : "",
                      comunaClient: setComuna ? setComuna : "",
                      calleClient: setCalle ? setCalle : "",
                      nCalleClient: setNroCalle ? setNroCalle : "",
                      dptoBlockClient: `${setDpto ? setDpto : ""} ${setPiso ? setPiso : ""}`,
                      ctaCtoClient: detailClient?.CTA_CTO
                    }}
                  />
                </div>

              </div>
            </CGE.PanelSection>
            <CGE.PanelSection
              title={
                <>
                  2.{solicitud ? " Solicitante" : "Reclamante"}
                </>
              }
            >
              <div class="row">
                <div class="col-md-12">
                  <CGE.Heading
                    size="4"
                    text={solicitud ? " Solicitante" : "Reclamante"}
                  />
                </div>
                <div class="col-md-6">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.validated?.RUTReclamante || (errors?.empty?.RUTReclamante)}
                    msgError={`Debes ingresar un RUT ${solicitud ? "Solicitante" : "Reclamante"} válido.`}
                    idFormElement="RUTReclamante"
                    labelName="Rut:"
                    mandatoryElement={true}
                    maxLength="12"
                    typeElement="input-mask"
                    typeFormElement="text"
                    value={values.RUTReclamante}
                    beforeMaskedValueChange={beforeMaskedValueChangeRut}
                    formatChars={{
                      9: "[0-9]",
                      k: "[Kk0-9]",
                    }}
                    mask="9.999.999-kk"
                    maskChar={null}
                  />
                </div>
                <div class="col-md-6">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.empty?.NombReclamante}
                    msgError={`Debes ingresar el nombre del ${solicitud ? "solicitante" : "reclamante"}`}
                    idFormElement="NombReclamante"
                    labelName="Nombre:"
                    mandatoryElement={true}
                    maxLength="40"
                    typeElement="input"
                    typeFormElement="text"
                    value={values.NombReclamante}
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.empty?.lastName}
                    msgError={`Debes ingresar el apellido paterno del ${solicitud ? "solicitante" : "reclamante"}`}
                    idFormElement="lastName"
                    labelName="Apellido Paterno:"
                    mandatoryElement={true}
                    maxLength="40"
                    typeElement="input"
                    typeFormElement="text"
                    value={values.lastName}
                  />
                </div>
                <div class="col-md-6">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.empty?.motherLastName}
                    msgError={`Debes ingresar el apellido materno del ${solicitud ? "solicitante" : "reclamante"}`}
                    idFormElement="motherLastName"
                    labelName="Apellido Materno:"
                    mandatoryElement={true}
                    maxLength="40"
                    typeElement="input"
                    typeFormElement="text"
                    value={values.motherLastName}
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <CGE.Heading
                    size="4"
                    text={
                      <>
                        Domicilio del {solicitud ? "Solicitante" : "Reclamante"}
                      </>
                    }
                  />
                </div>
                <div class="col-md-3">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.empty?.ComunaReclamante}
                    msgError={`Debes seleccionar la comuna del ${solicitud ? "solicitante" : "reclamante"}`}
                    idFormElement="ComunaReclamante"
                    labelName="Comuna:"
                    listOptions={allComunas}
                    mandatoryElement={true}
                    typeElement="select"
                    typeFormElement="text"
                    value={values.ComunaReclamante}
                  />
                </div>
                <div class="col-md-4">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.empty?.CalleReclamante}
                    msgError={`Debes ingresar la Calle del ${solicitud ? "solicitante" : "reclamante"}`}
                    idFormElement="CalleReclamante"
                    labelName="Calle:"
                    mandatoryElement={true}
                    maxLength="50"
                    typeElement="input"
                    typeFormElement="text"
                    value={values.CalleReclamante}
                  />
                </div>
                <div class="col-md-2">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.empty?.NroCalleReclamante}
                    msgError={`Debes ingresar el número de Calle del ${solicitud ? "solicitante" : "reclamante"}`}
                    idFormElement="NroCalleReclamante"
                    labelName="N°:"
                    mandatoryElement={true}
                    maxLength="10"
                    typeElement="input"
                    typeFormElement="text"
                    value={values.NroCalleReclamante}
                  />
                </div>
                <div class="col-md-3">
                  <CGE.FormsField
                    handleChange={handleChange}
                    idFormElement="blockOrDptoReclamante"
                    labelName="Block/Dpto:"
                    maxLength="10"
                    typeElement="input"
                    typeFormElement="text"
                    value={values.blockOrDptoReclamante}
                  />
                </div>
                <div class="col-md-6">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.validated?.EmailReclamante || (errors?.empty?.EmailReclamante)}
                    msgError={`Debes ingresar un ${solicitud ? "Email Solicitante" : "Email Reclamante"} válido`}
                    idFormElement="EmailReclamante"
                    labelName="Email:"
                    mandatoryElement={true}
                    maxLength="100"
                    typeElement="input"
                    typeFormElement="text"
                    value={values.EmailReclamante}
                  />
                </div>
                <div class="col-md-6">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.validated?.TelefReclamante || (errors?.empty?.TelefReclamante)}
                    msgError={"Debes ingresar un teléfono válido"}
                    idFormElement="TelefReclamante"
                    labelName="Teléfono:"
                    mandatoryElement={true}
                    typeElement="input-mask"
                    typeFormElement="text"
                    value={values.TelefReclamante}
                    formatChars={{
                      9: "[0-9]",
                    }}
                    mask="999999999"
                  />
                </div>
              </div>
            </CGE.PanelSection>
            <CGE.PanelSection
              title={
                <>
                  3. Descripción {solicitud ? "de la Solicitud" : "del Reclamo"}
                </>
              }
            >
              <div class="row pb-0">
                <div class="col-md-6">
                  <CGE.FormsField
                    handleChange={(event) => handleSelectChange(event, setFieldValue, values.CdgTipoReclamo)}
                    hasError={errors?.empty?.CdgTipoReclamo}
                    msgError={`Debes seleccionar el Tipo de ${solicitud ? "Solicitud" : "Reclamo"}`}
                    idFormElement="CdgTipoReclamo"
                    labelName={
                      <>
                        Tipo de {solicitud ? "Solicitud" : "Reclamo"}:
                      </>
                    }
                    listOptions={optionsInteraction}
                    mandatoryElement={true}
                    typeElement="select"
                    typeFormElement="text"
                    value={!responseService ? values.CdgTipoReclamo : values.CdgTipoReclamo = "0"}
                  />
                </div>
                {showForm && (
                  <div className="col-md-6">
                    <CGE.FormsField
                      handleChange={handleChange}
                      idFormElement="Fecha"
                      mandatoryElement={true}
                      typeElement="input"
                      typeFormElement="date"
                      labelName="Fecha en la que ocurrió el evento:"
                      placeholder="Fecha en la que ocurrió el evento"
                      hasError={errors?.validated?.Fecha || errors?.empty?.Fecha}
                      msgError="Debes ingresar fecha del evento"
                      value={values.Fecha}
                    />
                  </div>
                )}
              </div>

              {isContingencyMerchandiseClaim && (
                <div className="row pb-0">
                  <div className="col-md-6">
                    <CGE.FormsField
                      handleChange={(event) => handleAmountChange(event, setFieldValue, values.EstimacionMontoAfectacion)}
                      hasError={errors?.empty?.EstimacionMontoAfectacion}
                      msgError="Debes seleccionar la Estimación de Monto Afectación"
                      idFormElement="EstimacionMontoAfectacion"
                      labelName="Estimación de Monto Afectación:"
                      listOptions={AMOUNT_OPTIONS}
                      mandatoryElement={true}
                      typeElement="select"
                      typeFormElement="text"
                      value={values.EstimacionMontoAfectacion}
                    />
                  </div>
                </div>
              )}

              {showForm && (
                <div className="row pb-0">
                  <CGE.Text
                    text={isContingencyMerchandiseClaim && values.EstimacionMontoAfectacion === GREATER_AMOUNT
                      ? "Dado que su estimación corresponde a daños mayores, complete la siguiente información: Cédula de identidad y Boleta o factura de la mercadería. Formatos aceptados: .jpg, .jpeg, .png, .pdf y no superar 2 MB."
                      : "Adjuntar la siguiente documentación requerida. Formatos aceptados: .jpg, .jpeg, .png, .pdf y no superar 2 MB."}
                    size="1"
                  />
                  <div className="col-md-6">
                    <FileUploader
                      idInput="CedulaIdentidad"
                      labelInput="Cédula de Identidad: "
                      deleteFile={() => {
                        setFieldValue('CedulaIdentidad', '');
                        clearFileInput('CedulaIdentidad');
                      }}
                      onFileSelectSuccess={(file) => setFieldValue('CedulaIdentidad', file)}
                      setErroUploadFile={setErroUploadFile}
                      dataProps={props}
                      mandatoryElement={true}
                      maxFileSize={props.tamano_maximo_de_archivo_MB}
                      typeFile={props?.documento_extension}
                      msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                      multiFiles={false}
                      hasError={errors?.empty?.CedulaIdentidad}
                      msgError="Debes adjuntar Cédula de Identidad"
                    />
                  </div>

                  {(!isContingencyMerchandiseClaim || values.EstimacionMontoAfectacion === GREATER_AMOUNT) && (
                    <div className="col-md-6">
                      <FileUploader
                        idInput="Cotizacion"
                        labelInput={isContingencyMerchandiseClaim ? "Boleta o factura de la mercadería: " : "Cotización: "}
                        deleteFile={() => {
                          setFieldValue('Cotizacion', '');
                          clearFileInput('Cotizacion');
                        }}
                        onFileSelectSuccess={(file) => setFieldValue('Cotizacion', file)}
                        setErroUploadFile={setErroUploadFile}
                        dataProps={props}
                        mandatoryElement={!isDamagedApplianceClaim}
                        maxFileSize={props.tamano_maximo_de_archivo_MB}
                        typeFile={props?.documento_extension}
                        msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                        multiFiles={false}
                        hasError={errors?.empty?.Cotizacion}
                        msgError={isContingencyMerchandiseClaim ? "Debes adjuntar Boleta o factura de la mercadería" : "Debes adjuntar Cotización"}
                      />
                    </div>
                  )}

                  {!isContingencyMerchandiseClaim && (
                    <>
                      <div className="col-md-6">
                        <FileUploader
                          idInput="InformeTecnico"
                          labelInput="Informe del servicio Técnico: "
                          deleteFile={() => {
                            setFieldValue('InformeTecnico', '');
                            clearFileInput('InformeTecnico');
                          }}
                          onFileSelectSuccess={(file) => setFieldValue('InformeTecnico', file)}
                          setErroUploadFile={setErroUploadFile}
                          dataProps={props}
                          mandatoryElement={!isDamagedApplianceClaim}
                          maxFileSize={props.tamano_maximo_de_archivo_MB}
                          typeFile={props?.documento_extension}
                          msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                          multiFiles={false}
                          hasError={errors?.empty?.InformeTecnico}
                          msgError="Debes adjuntar Informe Técnico de servicio técnico"
                        />
                      </div>
                      <div className="col-md-6">
                        <FileUploader
                          idInput="FotoUno"
                          labelInput="Foto uno: "
                          deleteFile={() => {
                            setFieldValue('FotoUno', '');
                            clearFileInput('FotoUno');
                          }}
                          onFileSelectSuccess={(file) => setFieldValue('FotoUno', file)}
                          setErroUploadFile={setErroUploadFile}
                          dataProps={props}
                          mandatoryElement={true}
                          maxFileSize={props.tamano_maximo_de_archivo_MB}
                          typeFile={props?.documento_extension}
                          msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                          multiFiles={false}
                          hasError={errors?.empty?.FotoUno}
                          msgError="Debes adjuntar Foto uno"
                        />
                      </div>
                      <div className="col-md-6">
                        <FileUploader
                          idInput="FotoDos"
                          labelInput="Foto dos: "
                          deleteFile={() => {
                            setFieldValue('FotoDos', '');
                            clearFileInput('FotoDos');
                          }}
                          onFileSelectSuccess={(file) => setFieldValue('FotoDos', file)}
                          setErroUploadFile={setErroUploadFile}
                          dataProps={props}
                          mandatoryElement={false}
                          maxFileSize={props.tamano_maximo_de_archivo_MB}
                          typeFile={props?.documento_extension}
                          msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                          multiFiles={false}
                          hasError={false}
                          msgError=""
                        />
                      </div>
                      <div className="col-md-6">
                        <FileUploader
                          idInput="FotoTres"
                          labelInput="Foto tres: "
                          deleteFile={() => {
                            setFieldValue('FotoTres', '');
                            clearFileInput('FotoTres');
                          }}
                          onFileSelectSuccess={(file) => setFieldValue('FotoTres', file)}
                          setErroUploadFile={setErroUploadFile}
                          dataProps={props}
                          mandatoryElement={false}
                          maxFileSize={props.tamano_maximo_de_archivo_MB}
                          typeFile={props?.documento_extension}
                          msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                          multiFiles={false}
                          hasError={false}
                          msgError=""
                        />
                      </div>
                    </>
                  )}

                  <div className="col-md-12">
                    <CGE.Text
                      className="color-blue font-weight-bold mb-2"
                      size="2"
                      text="(*): Si no se cuenta con todos los documentos obligatorios en el presente formulario, el reclamo no será procesado."
                    />
                  </div>
                </div>
              )}
              {tag === 'RI' && <div class="row pb-0">
                <div class="col-md-6 d-flex flex-row">
                  <CGE.CheckBoxGroup
                    labelNameCheckBoxGroup="Existe Peligro:"
                    optionsGroup={[{
                      "checked": valueCheckBox,
                      "handleChange": () => setValueCheckBox((val) => !val),
                      "idFormElement": "OfrecePeligro",
                      "labelName": "Sí",
                      "typeElement": "input",
                      "typeFormElement": "checkbox",
                      "value": valueCheckBox ? values.OfrecePeligro = "S" : values.OfrecePeligro = "N",
                    },
                    ]}
                  />
                </div>
              </div>}
              <div class="row pt-0 pb-0">
                <div class="col-md-12 ">
                  <CGE.FormsField
                    handleChange={handleChange}
                    hasError={errors?.empty?.Observacion}
                    msgError={"Debes ingresar la Descripción"}
                    idFormElement="Observacion"
                    labelName="Descripción:"
                    mandatoryElement={true}
                    maxLength="900"
                    numberOfRows="4"
                    typeElement="textarea"
                    textAfterMandatory={!solicitud && "Detalle su reclamo lo más claro posible, nos permitirá entregarle una mejor atención."}
                    value={!responseService ? values.Observacion : values.Observacion = ""}
                  />
                </div>
              </div>
              <div class="row pt-0 ">
                <div className="col-md-12">
                  <CGE.Text
                    size="2"
                    text={
                      <>
                        Quedan {900 - values.Observacion.length} caracteres
                      </>
                    }
                  />
                </div>
              </div>
              {!getPageLayoutType() &&
                <div className="col-md-12 d-flex flex-column px-0">
                  <CGE.FieldRecaptcha
                    onChange={onChangeReCaptcha}
                    sitekey={properties.api_key_recaptcha}
                  />
                </div>
              }
              <div class="row d-flex flex-row-reverse">
                <div className="pr-3">
                  <CGE.Button
                    label="Enviar"
                    typeButton="submit"
                    type="primary"
                  />
                </div>
              </div>
            </CGE.PanelSection>
          </form>
        )}
      </Formik>
      {visibleModal && !visibleModalError && !error && (
        <AlertModal
          titleModal="Advertencia"
          msgModal={state.responseService}
          observer={observer}
          onClose={onClose}
          status="warning"
        />
      )}
    </div>
  );
};


export default FormsGeneric;
